import React from 'react';
import PropTypes from 'prop-types';
import {ErrorBoundary as SentryErrorBoundary} from '@sentry/react';

import ErrorDisplay from 'common/errors/error-display/ErrorDisplay';

const FallbackComponent = ({error, componentStack, resetError}) => (
    <ErrorDisplay
        error={error}
        componentStack={componentStack}
        resetError={resetError}
    />
);

FallbackComponent.propTypes = {
    error: PropTypes.instanceOf(Error).isRequired,
    componentStack: PropTypes.string.isRequired,
    resetError: PropTypes.func.isRequired,
};

const DomainErrorBoundary = ({children, pathname, routePath}) => {
    const setTagsBeforeCapture = (scope) => {
        scope.setTag('path', pathname);
    };

    return (
        <SentryErrorBoundary
            key={routePath}
            fallback={FallbackComponent}
            beforeCapture={setTagsBeforeCapture}
        >
            {children}
        </SentryErrorBoundary>
    );
};

DomainErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    pathname: PropTypes.string.isRequired,
    routePath: PropTypes.string,
};

export default DomainErrorBoundary;
